import CryptoApp from "./CryptoApp";
const tasks = [
  { id: "1", words: ["КОМПЬЮТЕР", "РОТОР","ОКО"], cryptoKey: "отпюкьерм" },
  

];
const cryptoRoutes = tasks.flatMap((task) => [
  {
    path: `/crypto/${task.id}`,
    element: <CryptoApp words={task.words} cryptoKey={task.cryptoKey} random = {false}/>,
  },
  {
    path: `/crypto/${task.id}/r`,
    element: <CryptoApp words={task.words} cryptoKey={task.cryptoKey} random = {true}/>,
  },
]);
export default cryptoRoutes;
